import React from "react";
import { TagContainer } from "./styles";

const Tag = props => {
  return (
    <TagContainer {...props}>
      <div className="text">{props.children}</div>
    </TagContainer>
  );
};

export default Tag;
